<div class="family-form__grid" [attr.data-testid]="testId('new-form')">
  @if (nameMode === 'split') {
    <div class="form-group family-form__field">
      <label [for]="idPrefix + '-first-name'">First name</label>
      <input
        [id]="idPrefix + '-first-name'"
        type="text"
        class="form-control"
        [class.error]="errors.firstName"
        [(ngModel)]="model.firstName"
        [disabled]="disabled || contactLocked"
      />
      @if (errors.firstName) {
        <div class="field-error">{{ errors.firstName }}</div>
      }
    </div>
    <div class="form-group family-form__field">
      <label [for]="idPrefix + '-last-name'">Last name</label>
      <input
        [id]="idPrefix + '-last-name'"
        type="text"
        class="form-control"
        [class.error]="errors.lastName"
        [(ngModel)]="model.lastName"
        [disabled]="disabled || contactLocked"
      />
      @if (errors.lastName) {
        <div class="field-error">{{ errors.lastName }}</div>
      }
    </div>
  } @else {
    <div class="form-group family-form__field">
      <label [for]="idPrefix + '-full-name'">Full Name</label>
      <input
        [id]="idPrefix + '-full-name'"
        type="text"
        class="form-control"
        [class.error]="errors.firstName || errors.lastName"
        [(ngModel)]="model.fullName"
        [disabled]="disabled || contactLocked"
      />
      @if (errors.firstName || errors.lastName) {
        <div class="field-error">{{ errors.firstName || errors.lastName }}</div>
      }
    </div>
  }
  <div class="form-group family-form__field">
    <label [for]="idPrefix + '-phone'">Phone number</label>
    <input
      [id]="idPrefix + '-phone'"
      type="tel"
      class="form-control"
      [attr.maxlength]="phoneMaxLength"
      [class.error]="errors.phone"
      [ngModel]="model.phone"
      (input)="onPhoneInput($event)"
      [disabled]="disabled || contactLocked"
    />
    @if (errors.phone) {
      <div class="field-error">{{ errors.phone }}</div>
    }
  </div>
  <div class="form-group family-form__field" [class.family-form__field--wide]="nameMode === 'full'">
    <label [for]="idPrefix + '-plate'">License plate <span class="required">*</span></label>
    <div class="family-form__plate">
      <mat-select
        class="form-select family-form__state"
        panelClass="family-discount-panel"
        disableOptionCentering
        aria-label="License plate state"
        [(ngModel)]="model.state"
        [disabled]="disabled"
      >
        @for (state of states; track state.code) {
          <mat-option [value]="state.code">{{ state.code }}</mat-option>
        }
      </mat-select>
      <input
        [id]="idPrefix + '-plate'"
        type="text"
        class="form-control"
        maxlength="20"
        [attr.data-testid]="testId('plate')"
        [class.error]="errors.plate"
        [(ngModel)]="model.plate"
        [disabled]="disabled"
      />
    </div>
    @if (errors.plate) {
      <div class="field-error">{{ errors.plate }}</div>
    }
  </div>
  @if (packageMode !== 'hidden') {
    <div
      class="form-group family-form__field"
      [class.family-form__field--wide]="nameMode === 'full'"
    >
      <label [for]="idPrefix + '-package'">Package <span class="required">*</span></label>
      <mat-select
        [id]="idPrefix + '-package'"
        class="form-select"
        panelClass="family-discount-panel"
        disableOptionCentering
        [attr.data-testid]="testId('package')"
        [class.error]="errors.packageId"
        [(ngModel)]="model.packageId"
        [disabled]="disabled || packageMode === 'readonly'"
      >
        @for (item of packages; track item.value) {
          <mat-option [value]="item.value">{{ item.label }}</mat-option>
        }
      </mat-select>
      @if (errors.packageId) {
        <div class="field-error">{{ errors.packageId }}</div>
      }
    </div>
  }
</div>
@if (discountMode !== 'hidden' || price) {
  <div class="family-member-form__discount-row">
    @if (discountMode !== 'hidden') {
      <div class="family-discount">
        <span class="family-discount__label">Discount</span>
        <mat-select
          class="form-select family-discount__select"
          panelClass="family-discount-panel"
          disableOptionCentering
          aria-label="Discount"
          [attr.data-testid]="testId('discount')"
          [(ngModel)]="model.discountValue"
          [disabled]="disabled || discountMode === 'readonly'"
        >
          @for (item of discounts; track item.value) {
            <mat-option [value]="item.value">{{ item.label }}</mat-option>
          }
        </mat-select>
      </div>
    }
    @if (price) {
      <div class="family-price" [attr.data-testid]="testId('new-price')">
        <span class="family-price__label">{{ priceCaption }}</span>
        <span class="family-price__value">{{ money(price.recurringPrice) }}{{ priceUnit }}</span>
        @if (showListPrice) {
          <s class="family-price__was">{{ money(price.list) }}/mo</s>
        }
      </div>
    }
  </div>
}
@if (errors.discount) {
  <div class="field-error">{{ errors.discount }}</div>
}
